import type { Messages } from '@/lib/i18n'

// Neformalus „tu“ stilius, lyčiai neutralios formos.
export const lt: Messages = {
  'app.tagline': 'Skubu ar svarbu? Susidėliok.',
  'nav.back': 'Atgal',
  'nav.done': 'Atlikta',
  'nav.settings': 'Nustatymai',
  'common.close': 'Uždaryti',
  'common.dismiss': 'Uždaryti',
  'common.offline': 'Nėra ryšio – pakeitimai nebus išsaugoti',

  'page.matrix': 'Matrica',
  'page.done': 'Atlikta',
  'page.settings': 'Nustatymai',
  'page.signIn': 'Prisijungimas',

  'quadrant.do.label': 'Daryk',
  'quadrant.do.hint': 'Skubu ir svarbu',
  'quadrant.do.action': 'Padaryk dabar',
  'quadrant.schedule.label': 'Suplanuok',
  'quadrant.schedule.hint': 'Svarbu, neskubu',
  'quadrant.schedule.action': 'Nuspręsk, kada darysi',
  'quadrant.delegate.label': 'Deleguok',
  'quadrant.delegate.hint': 'Skubu, nesvarbu',
  'quadrant.delegate.action': 'Kas gali tai padaryti už tave?',
  'quadrant.delete.label': 'Atmesk',
  'quadrant.delete.hint': 'Nei skubu, nei svarbu',
  'quadrant.delete.action': 'Atsisakyk',
  'quadrant.empty': 'Tuščia',
  'quadrant.emptyTitle': '„{quadrant}“ – tuščia',
  'quadrant.emptyBody': 'Čia pridėtos užduotys bus rodomos pagal prioritetą.',

  'axis.urgent': 'Skubu',
  'axis.notUrgent': 'Neskubu',
  'axis.important': 'Svarbu',
  'axis.notImportant': 'Nesvarbu',
  'board.urgent': '← Skubu',
  'board.notUrgent': 'Neskubu →',
  'board.important': 'Svarbu ↑',
  'board.notImportant': 'Nesvarbu ↓',
  'board.empty': 'Pridėk užduotį viršuje ir nutempk ją į tinkamą vietą.',
  'board.cardLabel': '{title}. Rodyklėmis perkeli, Enter – redaguoji.',
  'board.hasNotes': 'Yra pastabų',

  'date.yesterday': 'Vakar',
  'date.today': 'Šiandien',
  'date.tomorrow': 'Rytoj',
  'due.overdue': 'Vėluoja · {date}',
  'due.dueToday': 'Terminas šiandien',
  'due.title': 'Terminas: {date}',
  'due.pick': 'Data…',
  'due.label': 'Terminas',
  'due.clear': 'Išvalyti terminą',

  'composer.open': 'Pridėk užduotį…',
  'composer.placeholder': 'Ką reikia padaryti?',
  'composer.placeholderIn': 'Pridėk į „{quadrant}“…',
  'composer.pickQuadrant': 'Pasirink kvadrantą ↓',
  'composer.added': 'Pridėta į „{quadrant}“',

  'task.edit': 'Užduotis',
  'task.save': 'Išsaugoti',
  'task.title': 'Pavadinimas',
  'task.notes': 'Pastabos',
  'task.due': 'Terminas',
  'task.quadrant': 'Kvadrantas',
  'task.complete': 'Atlikta',
  'task.completeNamed': 'Pažymėti „{title}“ kaip atliktą',
  'task.delete': 'Ištrinti užduotį',
  'task.confirmDelete': 'Ištrinti „{title}“? To nebus galima atšaukti.',
  'task.deleted': 'Užduotis ištrinta',
  'task.completed': 'Atlikta: {title}',
  'task.restored': 'Grąžinta: {title}',
  'task.undo': 'Atšaukti',

  'done.count.one': '{count} atlikta užduotis',
  'done.count.few': '{count} atliktos užduotys',
  'done.count.many': '{count} atliktos užduoties',
  'done.count.other': '{count} atliktų užduočių',
  'done.clearAll': 'Išvalyti viską',
  'done.confirmClear': 'Negrįžtamai ištrinti visas atliktas užduotis ({count})?',
  'done.confirmDelete': 'Ištrinti „{title}“ visam laikui?',
  'done.restore': 'Grąžinti „{title}“',
  'done.delete': 'Ištrinti „{title}“',
  'done.emptyTitle': 'Dar nieko neatlikta',
  'done.emptyBody': 'Pažymėk užduotį kaip atliktą – ji atsiras čia.',

  'settings.account': 'Paskyra',
  'settings.signedInAs': 'Prisijungta kaip',
  'settings.language': 'Kalba',
  'settings.languageAuto': 'Pagal įrenginį',
  'settings.languageFooter': '„Pagal įrenginį“ – kalba parenkama pagal telefono ar naršyklės nustatymus.',
  'settings.passkeys': 'Face ID / prieigos raktai',
  'settings.passkeysFooter': 'Prisijunk su Face ID ar Touch ID vietoj slaptažodžio. Nustatyk kiekviename įrenginyje, kurį naudoji.',
  'settings.passkeyDefault': 'Prieigos raktas',
  'settings.passkeyAdded': 'Pridėta {date}',
  'settings.passkeyLastUsed': 'paskutinį kartą naudota {date}',
  'settings.passkeyRemove': 'Pašalinti prieigos raktą',
  'settings.passkeyConfirmRemove': 'Pašalinti „{name}“? Tame įrenginyje reikės jungtis slaptažodžiu.',
  'settings.passkeyAddDevice': 'Pridėti šį įrenginį',
  'settings.passkeySetUp': 'Nustatyti Face ID',
  'settings.passkeysUnsupported': 'Prieigos raktams reikia saugaus (https) ryšio ir juos palaikančios naršyklės.',
  'settings.install': 'Įdiegti į iPhone',
  'settings.installStep1': 'Safari naršyklėje bakstelėk',
  'settings.installShare': 'Bendrinti',
  'settings.installStep2': ', tada',
  'settings.installAddToHome': 'Pridėti prie pradžios ekrano',
  'settings.installStep3': '. Programėlė atsidarys per visą ekraną.',
  'settings.signOut': 'Atsijungti',

  'login.faceId': 'Prisijungti su Face ID',
  'login.orPassword': 'arba slaptažodžiu',
  'login.email': 'El. paštas',
  'login.password': 'Slaptažodis',
  'login.submit': 'Prisijungti',

  'passkey.alreadyRegistered': 'Šiame įrenginyje jau yra šios programėlės prieigos raktas.',
  'passkey.failed': 'Kažkas nepavyko.',
  'passkey.requestFailed': 'Užklausa nepavyko ({status}).',

  'nav.signIn': 'Prisijungti',
  'legal.privacy': 'Privatumo politika',

  'landing.subtitle': 'Eisenhowerio matrica tavo užduotims – telefone ir kompiuteryje.',
  'landing.cta': 'Susikurk nemokamą paskyrą',
  'landing.nameMeaning': 'Kai viskas surašyta ir sudėliota – lengviau.',
  'landing.howTitle': 'Keturi langeliai, du klausimai',
  'landing.howBody': 'Kiekvienai užduočiai paklausk: ar tai skubu? Ar svarbu? Atsakymai ją įdeda į vieną iš keturių langelių, o langelis pasako, ką daryti.',
  'landing.origin': 'Pavadinta JAV prezidento Dwighto D. Eisenhowerio garbei – jis pastebėjo, kad svarbūs dalykai retai būna skubūs, o skubūs – retai svarbūs.',
  'landing.quickAddTitle': 'Pridėk dviem bakstelėjimais',
  'landing.quickAddBody': 'Įrašyk užduotį, bakstelėk langelį. Viskas.',
  'landing.boardTitle': 'Laisvas tempimas dideliame ekrane',
  'landing.boardBody': 'Kompiuteryje užduotis tempk bet kur – vieta ir yra prioritetas.',
  'landing.faceIdTitle': 'Prisijungimas su Face ID',
  'landing.faceIdBody': 'Telefone nereikia rinkti slaptažodžio.',
  'landing.installTitle': 'Veikia kaip programėlė',
  'landing.installBody': 'iPhone: Safari → Bendrinti → Pridėti prie pradžios ekrano.',

  'login.forgot': 'Pamiršai slaptažodį?',
  'login.noAccount': 'Pirmą kartą?',
  'login.createAccount': 'Susikurk paskyrą',
  'login.resendConfirmation': 'Negavai patvirtinimo laiško?',

  'signup.title': 'Susikurk paskyrą',
  'signup.subtitle': 'Nemokamai – reikia tik el. pašto ir slaptažodžio.',
  'signup.passwordHint': 'Bent {count} simbolių',
  'signup.submit': 'Sukurti paskyrą',
  'signup.privacyNote': 'Kaip tvarkomi tavo duomenys:',
  'signup.haveAccount': 'Jau turi paskyrą?',

  'password.show': 'Rodyti slaptažodį',
  'password.hide': 'Slėpti slaptažodį',

  'auth.backToSignIn': 'Grįžti į prisijungimą',
  'forgot.title': 'Pamiršai slaptažodį?',
  'forgot.subtitle': 'Įrašyk el. paštą – atsiųsime nuorodą naujam slaptažodžiui sukurti.',
  'forgot.submit': 'Siųsti nuorodą',
  'reset.title': 'Sukurk naują slaptažodį',
  'reset.submit': 'Išsaugoti slaptažodį',
  'reset.requestNew': 'Užsakyti naują nuorodą',
  'resend.title': 'Patvirtink el. paštą',
  'resend.subtitle': 'Negavai nuorodos arba ji nebegalioja? Atsiųsime naują.',
  'resend.submit': 'Siųsti patvirtinimo nuorodą',

  'confirm.banner': 'Patvirtink el. paštą – nuorodą išsiuntėme adresu {email}.',
  'confirm.daysLeft.one': 'Liko {count} diena.',
  'confirm.daysLeft.few': 'Liko {count} dienos.',
  'confirm.daysLeft.many': 'Liko {count} dienos.',
  'confirm.daysLeft.other': 'Liko {count} dienų.',
  'confirm.resend': 'Siųsti dar kartą',

  'settings.emailUnconfirmed': 'Dar nepatvirtintas',
  'settings.emailPending': 'Laukiame, kol patvirtinsi {email}',
  'settings.resendConfirmation': 'Siųsti patvirtinimo nuorodą dar kartą',
  'settings.changeEmail': 'Keisti el. paštą',
  'settings.newEmail': 'Naujas el. paštas',
  'settings.currentPassword': 'Dabartinis slaptažodis',
  'settings.changePassword': 'Keisti slaptažodį',
  'settings.newPassword': 'Naujas slaptažodis',
  'settings.save': 'Išsaugoti',
  'settings.cancel': 'Atšaukti',
  'settings.deleteAccount': 'Ištrinti paskyrą',
  'settings.deleteAccountBody': 'Paskyra bus ištrinta visam laikui kartu su visomis užduotimis ir prieigos raktais. To nebus galima atšaukti.',
  'settings.deleteAccountPassword': 'Slaptažodis patvirtinimui',
  'settings.deleteAccountSubmit': 'Ištrinti mano paskyrą',
  'settings.deleteAccountSure': 'Ištrinti paskyrą ir visas užduotis visam laikui?',
}
